import React from 'react'
import { Icon } from '@mobi/component-library/Common/Icon'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { BetCardTitle } from '@mobi/betslip/Components/Common/BetCardTitle'
import { formatKambiCurrencyWithThousandMultiplier } from '@core/Areas/Kambi/Components/BetHistory/helpers/currencyFormat'
import { CountdownStatus } from '../Common/CountdownStatus'

export const SameGameMulti: React.FC<{
  ticket: BetLoopKambiShareCoupon
}> = ({ ticket }) => {
  const eventName = ticket.events[0]?.eventName || 'Unknown Meeting'
  const priceWin = ticket.bets[0].betOdds
  const legsCount = ticket.outcomes.length
  const multiTitleText = `${legsCount} Leg Same Game Multi`
  const multiCombinedReturn = formatKambiCurrencyWithThousandMultiplier(
    ticket.bets[0].potentialPayout
  )

  return (
    <>
      <BetCardTitle
        title={multiTitleText}
        rightComponent={multiCombinedReturn}
        bottomLeftComponent='icons'
      />
      <BetCard.EventDetails
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={eventName}
        statusComponent={<CountdownStatus ticket={ticket} />}
      />
      {ticket.outcomes.map(outcome => {
        return (
          <BetCard.SelectionInfo
            key={outcome.betOfferId}
            iconComponent={<Icon size='1.6rem' type='tab' />}
            heading={outcome.label}
            subHeading={ticket.betOffers.find(b => b.betOfferId === outcome.betOfferId)?.criterion}
            priceWin={formatKambiCurrencyWithThousandMultiplier(priceWin)}
          />
        )
      })}
    </>
  )
}
